export const Logo = ({ size = "md", className = "" }) => {
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-9";
  const t = size === "lg" ? "text-4xl" : size === "sm" ? "text-xl" : "text-2xl";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="footza-logo">
      <img src="/logo-mark.png" alt="FOOTZA" className={`${h} w-auto`} />
      <span className={`font-display ${t} font-black italic tracking-tight leading-none`}>
        FOOT<span className="fz-text-gradient">ZA</span>
      </span>
    </div>
  );
};

export const Avatar = ({ name, src, size = 40, className = "" }) => {
  const letters = (name || "FZ").split(/\s+/).filter(Boolean).slice(0, 2).map((s) => s[0]).join("").toUpperCase();
  return src ? (
    <img src={src} alt={name} style={{ width: size, height: size }} className={`rounded-full object-cover ring-2 ring-white/10 ${className}`} />
  ) : (
    <div style={{ width: size, height: size, fontSize: size * 0.36 }}
      className={`flex shrink-0 items-center justify-center rounded-full fz-gradient font-extrabold text-[#0b132b] ring-2 ring-white/10 ${className}`}>
      {letters}
    </div>
  );
};
